import React, { useState, useEffect } from "react";
import Homepage from "../homepage/Homepage";
import Postdetail from "../postdetail/Postdetail";
import Create from "../create/Create";
import LoginPage from "../loginpage/LoginPage";
import Profile from "../profile/Profile";
import About from "../about/About";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-quill/dist/quill.snow.css";

import { UserProvider } from "../usercontext/UserContext";
import ProtectedRoute from "../protectedroute/ProtectedRoute";

export default function App() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [posts, setPosts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/posts`)
      .then((res) => {
        if (!res.ok) throw new Error("Fehler beim Laden der Posts");
        return res.json();
      })
      .then((data) => {
        console.log("Empfangene Posts:", data);
        setPosts(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Lade Posts...</div>;
  if (error) return <div>Fehler: {error}</div>;

  return (
    <UserProvider>
      <Router basename="/semesterprojekt">
        <Routes>
          <Route path="/" element={<Homepage posts={posts} />} />
          <Route path="/post/:id" element={<Postdetail />} />
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <Create />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route path="/about" element={<About />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}
